<template>
  <game-detail v-if="active" v-bind="active" />
</template>

<script>
import GameDetail from '@/components/GameDetail'
import { games } from '../../public/wnbasim-latest.json'

export default {
  name: 'Home',
  components: {
    GameDetail,
  },
  data () {
    return {
      games,
    }
  },
  computed: {
    readyGames () {
      return this.games.filter((item) => Array.isArray(item.boxscore))
    },
    active () {
      return this.games.find((game) => game.slug === this.$route.params.id)
    },
  },
}
</script>
